<template>
    <v-data-table v-bind="$attrs"
                  dense
                  no-data-text="対象データがみつかりませんでした"
                  :show-select="show_select"
                  v-model="inputValue"
                  v-on="$listeners"
                  :options="computedOptions"
                  :footer-props="computedFooterProps">
        <template v-for="(slot, name) in $scopedSlots" v-slot:[name]="item">
            <slot :name="name" v-bind="item"></slot>
        </template>
        <template v-slot:footer.page-text="props">
            {{ props.itemsLength }} 件中 {{ props.pageStart }} 件～{{ props.pageStop }} 件を表示
        </template>
    </v-data-table>

</template>
<script>
    export default {
        props: {
            value: {
                type: String,
                required: true
            },
            show_select: {
                type: Boolean,
                default:true,
            },
            options: null,
            footerProps: null
        },
        computed: {
            inputValue: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            },
            computedOptions() {
                return this.options || this.itemsPerPageAllOption;
            },
            computedFooterProps() {
                return this.footerProps || { 'items-per-page-text': '表示件数', 'show-current-page': 'true', 'show-first-last-page': 'true', 'items-per-page-options': [10, 50, 100, -1] };
            },
        },
        //methods: {
        //    dblclick(event, { item }) {
        //        //チェックボックスをクリックしたときはreturn
        //        var target = event.target.className;
        //        if (target.match('checkbox')) {
        //            return;
        //        }
        //        this.$emit('dblClick',item)
        //    }
        //}
    }
</script>
